import debounce from 'debounce';

const handleResizeObserver = (entries) => {
    entries.forEach((entry) => {
        document.documentElement.style.setProperty('--product-overview-intro-height', `-${entry.target.offsetHeight}px`);
    })
};
const debounceHandleResizeObserver = debounce(handleResizeObserver, 300);
const header = document.querySelector('.pane--product-overview-intro');

if (header !== null) {
    const resizeObserver = new ResizeObserver(debounceHandleResizeObserver);

    resizeObserver.observe(header);
}
